import React, { useState } from "react";
// import useStyles from "./UserListFilters.css"
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, TextField, Typography } from "@material-ui/core";
import FactorySelect from "../../_shared/FactorySelect";
import PropTypes from "prop-types";
import PlantSelect from "../../_shared/PlantSelect";
import { UserListFiltersStructure } from "../../../_models/app.models";
import FormControlWrapper from "../../_shared/FormControlWrapper";
import { ExpandMore } from "@material-ui/icons";

const UserListFilters = (props) => {
    const labelMinWidth = 85
    const INITIAL_FILTER_STATE = {
        firstName: '',
        lastName: '',
        email: '',
        plantId: '',
        plantCode: '',
        factoryId: '',
        factoryCode: '',
        factoryList: []
    }

    const [filterState, setFilterState] = useState(INITIAL_FILTER_STATE);
    const [filtersAccordion, setFiltersAccordion] = useState(true)

    // Handle first name input change event
    const onFirstNameChange = (event) => {
        setFilterState({ ...filterState, firstName: event.target.value })
    }

    // Handle last name input change event
    const onLastNameChange = (event) => {
        setFilterState({ ...filterState, lastName: event.target.value })
    }

    // Handle email input change event
    const onEmailChange = (event) => {
        setFilterState({ ...filterState, email: event.target.value })
    }

    // Handle plant select dropdown change event
    const onPlantChange = (value) => {
        const plantIndex = props.plants.map(p => p.id).indexOf(value)
        setFilterState({
            ...filterState,
            plantId: value,
            plantCode: props.plants[plantIndex].code,
            factoryList: props.plants[plantIndex].factories
        })
    }

    // Handle factory select dropdown change event
    const onFactoryChange = (value) => {
        const factoryIndex = filterState.factoryList.map(f => f.id).indexOf(value)
        setFilterState({
            ...filterState,
            factoryId: value,
            factoryCode: filterState.factoryList[factoryIndex].code
        })
    }

    // Handle filter apply , return filter data through props
    const filterApply = () => {
        const filters: UserListFiltersStructure = {
            firstName: filterState.firstName,
            lastName: filterState.lastName,
            factoryCode: filterState.factoryCode,
            plantCode: filterState.plantCode,
            userEmail: filterState.email
        }
        props.onFilterChange(filters)
    }

    // handle filter clear event
    const filterClear = () => {
        setFilterState(INITIAL_FILTER_STATE)
        props.onFilterClear()
    }

    return (
        <Accordion
            className="appAccordion"
            expanded={filtersAccordion}
            onChange={(e, expanded) => setFiltersAccordion(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails className="contentPadding">
                <Grid container spacing={3} className="appFilterContainer">
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="First Name" variant="inline" labelMinWidth={labelMinWidth}>
                            <TextField
                                value={filterState.firstName}
                                size='small'
                                variant="outlined"
                                fullWidth
                                onChange={onFirstNameChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Last Name" variant="inline" labelMinWidth={labelMinWidth}>
                            <TextField
                                value={filterState.lastName}
                                size='small'
                                variant="outlined"
                                fullWidth
                                onChange={onLastNameChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Email" variant="inline" labelMinWidth={labelMinWidth}>
                            <TextField
                                value={filterState.email}
                                size='small'
                                variant="outlined"
                                fullWidth
                                onChange={onEmailChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Plant" variant="inline" labelMinWidth={labelMinWidth}>
                            <PlantSelect
                                plants={props.plants}
                                selectedValue={filterState.plantId}
                                onPlantChange={onPlantChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Factory" variant="inline" labelMinWidth={labelMinWidth}>
                            <FactorySelect
                                factories={filterState.factoryList}
                                selectedValue={filterState.factoryId}
                                onFactoryChange={onFactoryChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} className="appButtonGroup">
                        <Button variant="contained" onClick={filterClear}>Clear</Button>
                        <Button variant="contained" color="primary" onClick={filterApply}>Search</Button>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>

    )
}

UserListFilters.propTypes = {
    plants: PropTypes.array.isRequired,
    onFilterChange: PropTypes.func,
    onFilterClear: PropTypes.func
}
UserListFilters.defaultProps = {
    plants: []
}

export default UserListFilters;
